// DragNDropFunctions.js (versione refactoring)
export class DragNDropFunctions {
    static state = {
        drag: null
    };

    // Funzione condivisa per posizionare l'elemento drag all'interno di drop
    static _insertDragIntoDrop(drag, drop, clientY) {
        const dropRect = drop.getBoundingClientRect();
        // Se il mouse è nella parte alta del drop (primi 15%)
        if (clientY < dropRect.top + dropRect.height * 0.15) {
            drop.parentNode.insertBefore(drag, drop);
        }
        // Se il mouse è nella parte bassa del drop (ultimi 15%)
        else if (clientY > dropRect.bottom - dropRect.height * 0.15) {
            drop.parentNode.insertBefore(drag, drop.nextSibling);
        }
        // Altrimenti appendCome figlio
        else {
            drop.appendChild(drag);
        }
    }

    static handleDragStart = (event) => {
        event.dataTransfer.setData('text/plain', event.target.id);
        const img = new Image();
        img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
        event.dataTransfer.setDragImage(img, 0, 0);
        event.target.classList.add("dragging");
        this.setState({ drag: event.target });
    }

    static handleDragOver = (event) => {
        event.preventDefault();
        const drag = this.state.drag;
        const drop = event.target;
        if (drop.tagName.toUpperCase() === 'DIV' && drop.id) {
            try {
                this._insertDragIntoDrop(drag, drop, event.clientY);
            } catch (e) {
                // eventuale catch generico
            }
        }
    }

    static handleDrop = (event) => {
        event.preventDefault();
        const drag = this.state.drag;
        const drop = event.target;
        if (drop.tagName.toUpperCase() === 'DIV' && drop.id) {
            try {
                this._insertDragIntoDrop(drag, drop, event.clientY);
            } catch (e) {
                // eventuale catch generico
            }
        }
        drag.classList.remove("dragging");
        this.setState({ drag: null });
    }

    static setState(param) {
        this.state = param;
    }
}
